import { gql } from "@/gql/__generated__";
import {
  StandingOfferCreateMutation,
  StandingOffersQuery
} from "@/gql/__generated__/graphql";
import { useMutation } from "@apollo/client";
import { STANDING_OFFERS } from "./standingOffers";

const STANDING_OFFER_CREATE = gql(`
  mutation standingOfferCreate($input: StandingOfferInput!, $organizationId: ID!) {
    standingOfferCreate(input: $input, organizationId: $organizationId) {
      ...on StandingOffer {
        __typename
        id
        name
        message
        app {
          __typename
          id
          slug
          displayName
          description
        }
        createdAt
        status
        offeringOrganization {
          __typename
          id
          name
          slug
        }
        payment {
          __typename
          monthlyPriceUSD
          trialDays
        }
      }
      ... on OrganizationHasNoPaymentAccount {
        __typename
        organizationID
      }
      ... on OfferInvalidMonthlyPriceUSD {
        __typename
        monthlyPriceUSD
      }
      ... on OfferInvalidTrialDays {
        __typename
        trialDays
        maxTrialDays
      }
    }
  }
`);

export type StandingOfferCreate = Extract<
  StandingOfferCreateMutation["standingOfferCreate"],
  { __typename: "StandingOffer" }
>;

type StandingOffers = Extract<
  StandingOffersQuery["organization"],
  { __typename: "Organization" }
>["standingOffers"];

export function useStandingOfferCreate() {
  return useMutation(STANDING_OFFER_CREATE, {
    update(cache, { data }) {
      if (!data || data.standingOfferCreate.__typename !== "StandingOffer")
        return;

      const newStandingOffer = data.standingOfferCreate;

      cache.updateQuery(
        {
          query: STANDING_OFFERS
        },
        (cacheData) => {
          if (
            !cacheData ||
            cacheData.organization.__typename !== "Organization"
          )
            return undefined;

          const updatedStandingOffers: StandingOffers = [
            ...cacheData.organization.standingOffers,
            newStandingOffer
          ];

          const updatedQuery: StandingOffersQuery = {
            ...cacheData,
            organization: {
              ...cacheData.organization,
              standingOffers: updatedStandingOffers
            }
          };

          return updatedQuery;
        }
      );
    },
    refetchQueries: [STANDING_OFFERS]
  });
}
